export default function CardNumber(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={20} {...props}>
      <g data-name="Group 2561">
        <path
          data-name="Path 2100"
          d="M2.37 0h27.26A2.362 2.362 0 0 1 32 2.353v15.294A2.362 2.362 0 0 1 29.63 20H2.37A2.362 2.362 0 0 1 0 17.647V2.353A2.362 2.362 0 0 1 2.37 0Z"
          fill="#bababa"
        />
        <path
          data-name="Rectangle 1973"
          fill="#f8f8f8"
          d="M2.963 2.941h5.926v4.706H2.963z"
        />
        <path
          data-name="Exclusion 1"
          d="M26.076 17.058a2.951 2.951 0 0 1-1.778-.588 2.911 2.911 0 0 0 1.186-2.354 2.912 2.912 0 0 0-1.186-2.353 2.952 2.952 0 0 1 1.778-.588 2.955 2.955 0 0 1 2.962 2.941 2.955 2.955 0 0 1-2.962 2.942Zm-3.558 0a2.955 2.955 0 0 1-2.962-2.941 2.955 2.955 0 0 1 2.962-2.941 2.961 2.961 0 0 1 1.779.588 2.911 2.911 0 0 0-1.187 2.353 2.911 2.911 0 0 0 1.187 2.354 2.957 2.957 0 0 1-1.779.587Z"
          fill="#949494"
        />
        <g
          data-name="Group 1788"
          transform="translate(2.37 2.941)"
          fill="#f8f8f8"
        >
          <rect
            data-name="Rectangle 1976"
            width={3.556}
            height={1.176}
            rx={0.588}
            transform="translate(0 8.823)"
          />
          <rect
            data-name="Rectangle 1977"
            width={3.556}
            height={1.176}
            rx={0.588}
            transform="translate(5.926 8.823)"
          />
          <rect
            data-name="Rectangle 1979"
            width={13.407}
            height={1.176}
            rx={0.588}
            transform="translate(0 12.353)"
          />
          <rect
            data-name="Rectangle 1980"
            width={1.185}
            height={2.353}
            rx={0.593}
            transform="translate(18.37)"
          />
          <rect
            data-name="Rectangle 1981"
            width={1.185}
            height={2.353}
            rx={0.593}
            transform="translate(20.741)"
          />
          <rect
            data-name="Rectangle 1982"
            width={1.185}
            height={2.353}
            rx={0.593}
            transform="translate(23.111)"
          />
          <rect
            data-name="Rectangle 1983"
            width={1.185}
            height={2.353}
            rx={0.593}
            transform="translate(25.481)"
          />
        </g>
      </g>
    </svg>
  );
}
